/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-align:center;align-items:center}[_nghost-%COMP%]   .instant-join-iframe[_ngcontent-%COMP%]{width:100%;border:0}[_nghost-%COMP%]   .instant-join-iframe.instant-join-iframe--spaced[_ngcontent-%COMP%]{margin-top:1.25rem}"];
export { styles as styles };
//# sourceMappingURL=instant-join-iframe.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/components/instant-join-iframe/instant-join-iframe.component.scss.shim.ngstyle.js
// module id = 1475
// module chunks = 27 28 29